export default "__VITE_ASSET__RVMn5vcl__"